import type { SVGProps } from 'react';
const DawnFlagME = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-ME_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-ME_svg__a)">
      <path fill="#E6BE53" d="M0 0h22v16H0z" />
      <path
        fill="#E01826"
        fillRule="evenodd"
        d="M1.048 13.933a1 1 0 0 0 1 1h17.905a1 1 0 0 0 1-1V2.067a1 1 0 0 0-1-1H2.048a1 1 0 0 0-1 1z"
        clipRule="evenodd"
      />
      <path
        fill="#E6BE53"
        fillRule="evenodd"
        d="M10.434 2.859a.667.667 0 0 0-.262 1.098l.108.11c.125.128.297.2.476.2h.488c.179 0 .35-.072.476-.2l.107-.11a.667.667 0 0 0-.26-1.098l-.353-.12a.67.67 0 0 0-.428 0zm1.041 2.523a.667.667 0 0 1-.95 0l-.049-.049-.76-.773a.56.56 0 0 0-.654-.107l-.015.008a.548.548 0 0 0-.142.872l.716.73a.67.67 0 0 1 .123.761l-.286.583a.3.3 0 0 0-.03.126.286.286 0 0 1-.416.255l-.244-.124a.32.32 0 0 1-.083-.507.32.32 0 0 0 0-.447l-.23-.235a.7.7 0 0 1-.12-.17l-.446-.907a.7.7 0 0 1-.05-.135l-.166-.68a.667.667 0 0 0-1.184-.236l-.597.81a.67.67 0 0 0-.13.395v1.76q0 .155.068.294l.408.83a.7.7 0 0 0 .123.174l.896.912q.076.079.173.127l.9.459q.05.025.108.025c.25 0 .33.337.108.45l-.126.064a.3.3 0 0 0-.07.051l-.231.235a.367.367 0 0 1-.524 0 .367.367 0 0 0-.524 0l-.047.048a.43.43 0 0 0-.08.494l.206.419a.67.67 0 0 0 .598.373h.473a.7.7 0 0 0 .302-.073l.707-.36a.67.67 0 0 0 .296-.3l.216-.44a.337.337 0 1 1 .585.333l-.54.825a.667.667 0 0 0 .184.916l.654.445a.67.67 0 0 0 .75 0l.654-.445a.667.667 0 0 0 .183-.916l-.54-.825a.337.337 0 1 1 .585-.333l.216.44c.064.13.168.235.296.3l.707.36a.7.7 0 0 0 .303.073h.472a.67.67 0 0 0 .599-.373l.205-.419a.43.43 0 0 0-.08-.494l-.047-.048a.367.367 0 0 0-.523 0 .367.367 0 0 1-.524 0l-.231-.235a.3.3 0 0 0-.07-.051l-.126-.064c-.223-.114-.142-.45.108-.45a.24.24 0 0 0 .108-.025l.9-.459a.7.7 0 0 0 .173-.127l.896-.912q.075-.077.123-.173l.408-.831a.7.7 0 0 0 .068-.294v-1.76a.67.67 0 0 0-.13-.395l-.597-.81a.667.667 0 0 0-1.184.236l-.167.68a.7.7 0 0 1-.05.135l-.445.907a.7.7 0 0 1-.12.17l-.23.235a.32.32 0 0 0 0 .447c.15.153.108.41-.083.507l-.245.124a.286.286 0 0 1-.416-.255.3.3 0 0 0-.03-.126l-.285-.583a.67.67 0 0 1 .122-.76l.717-.73a.548.548 0 0 0-.142-.873l-.015-.008a.56.56 0 0 0-.655.107l-.76.773z"
        clipRule="evenodd"
      />
      <path
        fill="#215F90"
        fillRule="evenodd"
        d="M9.952 9.067c0 .193.327.257.42.087.183-.332.405-.62.628-.62s.445.288.627.62c.093.17.42.106.42-.087 0-.884-.469-1.6-1.047-1.6-.579 0-1.048.716-1.048 1.6"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagME;
